import { Trans } from 'react-i18next';

export interface SurveyAnswerDescriptionProps {
    isSelfEvaluation: boolean;
    selfEvaluationDescription: string;
    managerLabel: string;
}

export const SurveyAnswerDescription = ({
    isSelfEvaluation,
    selfEvaluationDescription,
    managerLabel,
}: SurveyAnswerDescriptionProps) => {
    if (isSelfEvaluation) {
        return selfEvaluationDescription;
    }

    return (
        <Trans
            i18nKey={'answer.surveyAnswer.featureItem.description'}
            components={{ bold: <b /> }}
            values={{ managerLabel }}
        />
    );
};
